import React from "react";
import { useI18n } from "../lib/i18n";
import StatusBadge from "./StatusBadge";
import { FileText } from "lucide-react";

export default function SourceCitation({ source, index }) {
  const { t } = useI18n();
  const typeLabel = t(`types.${source.document_type}`, source.document_type);
  const statusLabel = t(`status.${source.status}`, source.status);

  return (
    <div
      className="flex items-start gap-3 text-sm text-foreground/80 py-2 border-b border-primary/5 last:border-none"
      data-testid={`source-item-${index}`}
    >
      <div className="shrink-0 w-7 h-7 bg-accent/20 text-[#b4551c] font-mono text-xs font-semibold rounded-sm flex items-center justify-center">
        {index}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-0.5">
          <span className="font-mono text-xs text-primary font-medium">
            {source.reference}
          </span>
          <span className="text-[10px] uppercase tracking-wider text-foreground/50">
            {typeLabel}
          </span>
          <StatusBadge status={source.status} label={statusLabel} />
        </div>
        <div className="text-xs text-foreground/60 mb-1 font-mono">
          {source.article ? `${source.article} ` : ""}
          {source.page ? `· ${t("chat.page")} ${source.page}` : ""}
          {source.similarity != null ? (
            <span className="ml-2 text-foreground/40">
              sim={source.similarity.toFixed(2)}
            </span>
          ) : null}
        </div>
        <p className="text-[13px] leading-relaxed text-foreground/75 italic">
          « {source.excerpt} »
        </p>
      </div>
    </div>
  );
}
